import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=2f11a0fe&"
import script from "./Charges.vue?vue&type=script&lang=js&"
export * from "./Charges.vue?vue&type=script&lang=js&"
import style0 from "./Charges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Charges.vue"
export default component.exports